module.exports = __webpack_public_path__ + "static/media/hamburger-menu-web.c5860f1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hamburger-menu-web.svg
// module id = 167
// module chunks = 0